<template>
    <div class="form-check form-check-inline">
        <input
            :id="id"
            v-model="isChecked"
            class="form-check-input"
            :class="[checkboxClass]"
            type="checkbox"
            :value="value"
            v-bind="$attrs"
            @change="$emit('change', $event)"
        >
        <label class="form-check-label task__item__label pointer" :for="id" :class="[labelClass, `text--${size}`]"> 
            <slot />
        </label>
    </div>
</template>

<script>
import { simpleUniqueID, wait } from "@/plugins/index";
/**
 * @group UI Components / Forms
 * A basic checkbox implementation with the default styling and label
 * <br>
 * ![image](https://cdn.filestackcontent.com/baI9CUMSfe0JrgTfYIr1)

 * <h2>Example</h2>
 * `<BaseCheckbox value="future" v-model="myValue">Save for the future</BaseCheckbox>`
 * `<BaseCheckbox value="option1" :values.sync="myArray">Option 1</BaseCheckbox>`
 */
export default {
    model: {
        event: "checked",
        prop: "values",
    },

    props: {
        // Define an HTML tag for your component.
        tag: {
            type: String,
            default: "div",
        },

        id: {
            type: String,
            default: () => `checkbox-${simpleUniqueID()}`, // Generate a default unique ID
        },
        
        size: { 
            type: String, 
            default: "sm",
            validator: (value) => {
                return ["xs", "sm", "md", "lg"].includes(value);
            },
        },

        // Define the checkbox value. Same as with normal checkbox input.
        value: {
            type: [String, Number, Boolean, null, undefined],
            default: null,
        },

        // Define a class or classes for the checkbox label
        labelClass: {
            type: String,
            default: undefined,
        },

        // Define a class or classes for the checkbox input
        checkboxClass: {
            type: String,
            default: undefined,
        },

        // Defines a list of currently selected or checked items for group scenarios.
        values: {
            type: Array,
            default: () => [],
        },
    },

    computed: {
        isChecked: {
            get() {
                if (Array.isArray(this.values)) {
                    return this.values.includes(this.value);
                }
                return !!this.values; // Handle boolean v-model
            },
            set(newValue) {
                let newValues;
                
                
                if (Array.isArray(this.values)) {
                    if (newValue) {                        
                        newValues = [...this.values, this.value];
                        
                        // Ensure uniqueness if needed
                        newValues = [...new Set(newValues)];
                    } else {
                        newValues = this.values.filter((val) => val !== this.value);
                    }
                } else {
                    newValues = newValue;
                }
                this.$emit("checked", newValues);
            },
        },
    },
};
</script>